import React from 'react';
import { useDispatch } from 'react-redux';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import PublicRoutes from './public';
import PrivateRoutes from './private';

import Footer from 'components/Footer';
import Alert from 'components/Alert';
import Loading from 'components/Loading';
import Modal from 'components/Modal/ModalGenerico';
import ModalColor from 'components/Modal/ModalColor';
import ModalEncaminhar from 'components/Modal/ModalEncaminhar/index';
import ModalJustificativa from 'components/Modal/ModalJustificativa/index';
import ModalAcessoNegado from 'components/Modal/ModalAcessoNegado';
import ModalUsuarioPendente from 'components/Modal/ModalUsuarioPendente';
import PageNotFound from 'pages/NotFound';

import SigninRedirect from 'pages/SigninRedirect';
import Home from 'pages/Home';
import { saveChangeLibras } from 'utils/acessibilidade';
export const paths = require('./paths');

export default function Routes() {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(saveChangeLibras());
  }, [dispatch]);

  return (
    <Loading>
      <iframe title="DownloadFile" id="download-file" style={{ display: 'none' }} />
      <Alert />
      <BrowserRouter>
        <ModalAcessoNegado />
        <Modal />
        <ModalEncaminhar />
        <ModalJustificativa />
        <ModalUsuarioPendente />
        <ModalColor />
        <Switch>
          <Route path={paths.publicRoot} component={PublicRoutes} />
          <Route path={paths.privateRoot} component={PrivateRoutes} />
          <Route path="/" exact component={Home} />
          <Route exact component={SigninRedirect} path={paths.signinRedirect} />
          <Route to={paths.notFound} component={PageNotFound} />
        </Switch>
      </BrowserRouter>
      <Footer />
    </Loading>
  );
}
